<template>
  <a-layout class="timingTask">
    <a-tabs default-active-key="1">
      <a-tab-pane key="1" tab="定时任务">
        <timing-task-table ref="timingTaskTable"></timing-task-table>
      </a-tab-pane>
      <a-tab-pane key="2" tab="定时任务日志">
        <timing-task-log-table ref="TimingTaskLogTable"></timing-task-log-table>
      </a-tab-pane>
    </a-tabs>
  </a-layout>
</template>

<script>
import TimingTaskTable from '@/views/timingTask/modules/timingTaskTable/timingTaskTable.vue'
import TimingTaskLogTable from '@/views/timingTask/modules/timingTaskLog/timingTaskLogTable.vue'

export default {
  name: 'FieldManage',
  components: { TimingTaskTable, TimingTaskLogTable },
  data () {
    return {
    }
  },
  created () {
  },
  methods: {}
}
</script>

<style lang="less" scoped>
.timingTask {
  overflow-y: hidden;
  background-color: #ffffff;
  padding: 20px;
}
/deep/.ant-tabs {
  height: 100%;
  .ant-tabs-content {
    height: 100%;
  }
}
</style>
